class TemplateHelper {

    injectTemplate(template) {
        this.template = template;
    }

}

export default TemplateHelper;
